import React, { useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Form, FormGroup, Spinner } from "reactstrap";
import { AuthButton, AuthInput } from "../../auth/style";
import { AppContext } from "../../context";
import { getCurrentUser, setAuthenticatedUser } from "../../auth/service";
import storeApi from "../storeApi";

const StoreAdminLogin = () => {
  const navigate = useNavigate();
  const { setCurrentUser } = useContext(AppContext) || {};
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const isMobileValid = useMemo(
    () => mobile.trim().length === 10 && /^\d+$/.test(mobile.trim()),
    [mobile]
  );
  const canSubmit = isMobileValid && password.trim().length > 0 && !isSubmitting;

  const toErrorText = (err, fallback) => {
    const raw =
      err?.message ??
      err?.error ??
      err?.response?.data?.message ??
      err?.response?.data?.error ??
      fallback;
    return typeof raw === "string" ? raw : fallback;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!canSubmit) return;

    setIsSubmitting(true);
    setError(null);
    try {
      const response = await storeApi.authAPI.adminLogin({
        mobile: mobile.trim(),
        password: password.trim(),
      });

      const root = response || {};
      const inner = root.data || {};
      const user = inner.user || root.user || null;
      const token = inner.token || root.token || null;
      if (!user || !token) {
        setError("Login failed: missing session payload.");
        return;
      }

      localStorage.setItem("storeAccessToken", token);
      setAuthenticatedUser({ token, user });
      if (typeof setCurrentUser === "function") setCurrentUser(getCurrentUser());
      navigate("/admin/dashboard", { replace: true });
    } catch (e) {
      setError(toErrorText(e, "Invalid mobile or password."));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-5 col-lg-4">
          <h2 className="mb-3 fw-bold text-center">Admin Login</h2>
          <p className="text-muted text-center mb-4">
            Sign in with mobile and password.
          </p>
          <Form onSubmit={handleSubmit}>
            <FormGroup className="mb-3">
              <AuthInput
                type="text"
                value={mobile}
                placeholder="Mobile Number"
                onChange={(ev) => setMobile(ev.target.value)}
                invalid={mobile.length > 0 && !isMobileValid}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <AuthInput
                type="password"
                value={password}
                placeholder="Password"
                onChange={(ev) => setPassword(ev.target.value)}
              />
            </FormGroup>
            {error ? <Alert color="danger">{error}</Alert> : null}
            <div className="d-grid">
              <AuthButton type="submit" color="primary" disabled={!canSubmit}>
                {isSubmitting ? (
                  <>
                    <Spinner size="sm">Loading...</Spinner> &nbsp;
                    <span>Signing in...</span>
                  </>
                ) : (
                  "Login"
                )}
              </AuthButton>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default StoreAdminLogin;
